import { Checkbox } from "@constants/variables";

const castNumberCheckboxValue = (
  value: string | number | null | undefined
): Checkbox => (`${value}` === Checkbox.ON ? Checkbox.ON : Checkbox.OFF);

export default castNumberCheckboxValue;
